import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiTwitter, FiFacebook } from 'react-icons/fi';

const Footer = () => (
  <footer style={{ borderTop: '1px solid #ddd', background: '#000', color: '#999', padding: '60px 40px 30px', fontFamily: 'Montserrat, sans-serif', fontSize: '13px' }}>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', maxWidth: '1200px', margin: '0 auto' }}>
      <div>
        <h3 style={{ fontFamily: "'Cormorant Garamond', serif", color: '#fff', fontSize: '20px', letterSpacing: '3px', marginBottom: '15px' }}>HEANDSHESTYLE</h3>
        <p style={{ lineHeight: 1.8 }}>Redefining Elegance</p>
      </div>
      <div>
        <h4 style={{ color: '#C9A96E', marginBottom: '15px', letterSpacing: '2px', fontSize: '12px', textTransform: 'uppercase' }}>Quick Links</h4>
        {[['/', 'Home'], ['/shop', 'Shop'], ['/shop?gender=men', 'Men'], ['/shop?gender=women', 'Women']].map(([to, label]) =>
          <Link key={to} to={to} style={{ display: 'block', color: '#999', textDecoration: 'none', marginBottom: '10px' }}>{label}</Link>
        )}
      </div>
      <div>
        <h4 style={{ color: '#C9A96E', marginBottom: '15px', letterSpacing: '2px', fontSize: '12px', textTransform: 'uppercase' }}>Customer Service</h4>
        {['Contact Us', 'Shipping & Returns', 'FAQ', 'Size Guide'].map(item =>
          <p key={item} style={{ marginBottom: '10px', cursor: 'pointer' }}>{item}</p>
        )}
      </div>
      <div>
        <h4 style={{ color: '#C9A96E', marginBottom: '15px', letterSpacing: '2px', fontSize: '12px', textTransform: 'uppercase' }}>Connect</h4>
        <div style={{ display: 'flex', gap: '15px' }}>
          <FiInstagram size={18} style={{ color: '#999', cursor: 'pointer' }} />
          <FiTwitter size={18} style={{ color: '#999', cursor: 'pointer' }} />
          <FiFacebook size={18} style={{ color: '#999', cursor: 'pointer' }} />
        </div>
      </div>
    </div>
    <p style={{ textAlign: 'center', marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #333', color: '#666' }}>&copy; {new Date().getFullYear()} HeAndSheStyle. All rights reserved.</p>
  </footer>
);

export default Footer;
